import { Component, OnInit } from '@angular/core';
import { Company } from '../../models/company.model';
import { CompanyMockService } from '../../services/company-mock.service';

@Component({
  selector: 'bwc-followed-companies',
  templateUrl: './followed-companies.component.html',
  styleUrls: ['./followed-companies.component.scss'],
})
export class FollowedCompaniesComponent implements OnInit {
  followedCompanies: Company[] = [];

  constructor(private companyService: CompanyMockService) {}

  ngOnInit(): void {
    this.loadFollowed();
  }

  unfollow(company: Company): void {
    this.companyService.toggleFollowCompany(company);
    this.loadFollowed();
  }

  private loadFollowed(): void {
    this.companyService.getFollowedCompanies().subscribe(c => (this.followedCompanies = c));
  }
}
